import { render, staticRenderFns } from "./ModalBillDetails.vue?vue&type=template&id=55f7b1b5&scoped=true"
import script from "./ModalBillDetails.vue?vue&type=script&lang=js"
export * from "./ModalBillDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalBillDetails.vue?vue&type=style&index=0&id=55f7b1b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f7b1b5",
  null
  
)

export default component.exports